'use client'

import { useState, useEffect } from 'react'

/**
 * Hook to handle client-side hydration
 * Returns true only after component has mounted on client
 * 
 * @example
 * const mounted = useMounted()
 * if (!mounted) return null
 */
export function useMounted(): boolean {
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    setMounted(true)
  }, [])

  return mounted
}
